import { useState, useEffect } from 'react';

const useScrollScale = () => {
    const [scale, setScale] = useState(1);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            // Increased scale factor from 0.0001 to 0.0003
            const newScale = 1 + (scrollPosition * 0.0003);
            setScale(newScale);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return scale;
};

export default useScrollScale; 